import { SET_NYSERDA_IS_VISIBLE } from './constants';

const defaultState = { isVisible: false };

const nyserdaUI = (state = defaultState, action) => {
    switch (action.type) {
        case SET_NYSERDA_IS_VISIBLE:
            return { ...state, isVisible: action.isVisible };

        default:
            return state;
    }
};

export default nyserdaUI;



// WEBPACK FOOTER //
// ./src/containers/Inputs/NYSERDA/reducer.js